import { CSSProperties, memo } from 'react';
import cx from 'classnames';
import style from './Skeleton.module.sass';

interface SkeletonProps {
  className?: string;
  height?: string | number;
  width?: string | number;
  border?: string;
  count?: number;
}

export const Skeleton = memo((props: SkeletonProps) => {
  const { className, height, width, border, count } = props;

  const styles: CSSProperties = {
    width,
    height,
    borderRadius: border,
  };

  return count ? (
    <>
      {[...Array(count)].map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} className={cx(style.skeleton, className)} style={styles} />
      ))}
    </>
  ) : (
    <div className={cx(style.skeleton, className)} style={styles} />
  );
});
